/**
 * Normalize a boolean-like response from the adapter.
 * Some adapter endpoints return boolean or { data: boolean }; mutations (delete/disable) return a
 * fetch response whose success is carried by `ok` with no `data`.
 * @param res - raw adapter response
 * @returns boolean
 */
export function extractBoolean(res: unknown): boolean {
  if (res == null) return false;
  const obj = res as Record<string, unknown>;
  // A failed fetch response (ok === false) is never a successful result, even though its data is
  // null/undefined — without this guard `obj.data ?? res` coerces the response object itself to true.
  if (obj?.ok === false) return false;
  return Boolean(obj.data ?? res);
}
